<template>
  <el-dialog
    :visible="visible"
    @close="handleClose"
    title="操作记录"
    width="1000px"
  >
    <el-table
      v-loading="loading"
      :data="recordData"
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#f7f7f7' }"
    >
      <el-table-column prop="createTime" label="操作时间"></el-table-column>
      <el-table-column prop="phone" label="操作人"></el-table-column>
      <el-table-column prop="type" label="操作类型">
        <template slot-scope="{ row }">
          <span v-if="row.type === 0">新增</span>
          <span v-if="row.type === 1">修改</span>
        </template>
      </el-table-column>
      <el-table-column prop="mealType" label="套餐类型" width="150">
        <template slot-scope="scope">
          <span>{{ mealType[scope.row.mealType] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="300"
        prop="content"
        label="操作内容"
      ></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { madeRecord } from "@/api/package";
import { mealType } from "@/utils/enum";


export default {
  name: "RecordDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      mealType,
      recordData: [],
      loading: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getRecordList();
      }
    },
  },
  methods: {
    async getRecordList() {
      this.loading = true;
      try {
        const { data } = await this.$ajax.get(`${madeRecord}?id=${this.id}`);
        if (data?.code === 200) {
          this.recordData = data.data || [];
        }
      } catch (error) {
        console.error("获取操作记录失败:", error);
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
      setTimeout(() => {
        this.recordData = [];
      }, 200);
    },
  },
};
</script>
